const languageList = [
  {
    id: 1,
    name: 'English',
    value: 'en',
    headerText: 'Select language',
    buttonText: 'Continue',
    bodyText:
      'This will display Junction’s interface and email notification in your preferred language, but no user generated content. You can change language at any time in your user menu.',
  },
  {
    id: 2,
    name: 'Japanese (日本語 )',
    value: 'jp',
    headerText: '言語の選択',
    buttonText: '日本語',
    bodyText:
      'これにより、Junction のインターフェースと電子メール通知言語が変更されますが、プロジェクトのコンテンツ (分析データなど) は変更されません。 サイトヘッダーのユーザーメニューのリンクを使用していつでも言語を変更できます。',
  },
];
export default languageList;
